export default __webpack_public_path__ + "images/58_thumbnail.jpg";